import { gql } from '@apollo/client';

export default gql`
    {
        Languages {
            IdIdioma
            Idioma
        }
    }
`;